import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  success: false,
  loading: false,
  error: ''
};

const loginSlice = createSlice({
  name: 'login',
  initialState: initialState,
  reducers: {
    setSuccess: (state, action) => {
      return {...state, success: true, loading: false, error: ''};
    },
    loginUser() {
    },
    tryUserLogout() {
    },
    setLoading: (state, action) => {
      return {...state, loading: action.payload, error: ''};
    },
    setError: (state, action) => {
      return {...state, error: action.payload, loading: false};
    },
    reset: (state, action) => {
      return {...state, ...initialState};
    }
  }
});


export const {loginUser, setLoading, setSuccess, setError, reset: resetLoginSlice, tryUserLogout} = loginSlice.actions;

export default loginSlice.reducer;